import React, { useEffect, useState } from 'react';
import { usePublicTenant } from '../hooks/usePublicTenant';
import { supabase } from '../lib/supabaseClient';

/**
 * När tenant saknar supplier_portal-modulen visas "Leverantörsportalen är inte aktiverad"
 * istället för innehållet på /leverantor och /leverantor/registrera.
 */
export default function SupplierPortalGate({ children }: { children: React.ReactNode }) {
  const { tenantId, loading: tenantLoading } = usePublicTenant();
  const [portalEnabled, setPortalEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function check() {
      if (tenantLoading) {
        setLoading(true);
        return;
      }
      if (!tenantId) {
        setPortalEnabled(true);
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const { data, error } = await supabase.rpc('get_tenant_has_supplier_portal', {
          p_tenant_id: tenantId,
        });
        if (!cancelled) {
          setPortalEnabled(!error && data === true);
        }
      } catch {
        if (!cancelled) setPortalEnabled(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    check();
    return () => { cancelled = true; };
  }, [tenantId, tenantLoading]);

  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-indigo-600" />
      </div>
    );
  }

  if (!portalEnabled) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center bg-gray-50 px-4">
        <div className="text-center max-w-md">
          <h1 className="text-xl font-semibold text-gray-800 mb-2">Leverantörsportalen är inte aktiverad</h1>
          <p className="text-gray-600">
            Denna tjänst är för närvarande inte aktiverad för det här kontot. Kontakta din leverantör om du har frågor.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
